import React, { useCallback, useContext, useEffect, useState } from "react";
import { TableContext, UserContext } from "../../../context";
import { useWindowDimensions } from "../../../hooks";
import { IPlayer } from "../../../interfaces";
import { AvatarBoxHolder, ChallengeCardOnTheTable } from "../../molecules";
import logoUppiness from "../../../assets/icons/logoUppiness.svg";

export const BoardTableEllipseMemo = () => {
    const { width, height } = useWindowDimensions();
    const { playersInNewOrder } = useContext(UserContext);
    const { oldUserAngles, userAngles, isLogoOnTheTableBlured, setTheIndexOfTheUserPositionedAt270Degrees } = useContext(TableContext);
    const [elipseWidth, setElipseWidth] = useState(width * 0.64);
    const [elipseHeight, setElipseHeight] = useState(width * 0.44);
    let blureTheElement = isLogoOnTheTableBlured ? "blure_the_element" : "";

    const setTableWidthAndHeight = useCallback(() => {
        setElipseWidth(width * 0.64);
        setElipseHeight(width * 0.44);
    }, [width]);

    useEffect(() => {
        setTableWidthAndHeight();
    }, [setTableWidthAndHeight]);

    useEffect(() => {
        playersInNewOrder.forEach((_player: IPlayer, index: number) => {
        if (userAngles[index] === 270) 
                            setTheIndexOfTheUserPositionedAt270Degrees(index);
        });
    }, [playersInNewOrder, setTheIndexOfTheUserPositionedAt270Degrees, userAngles])

    return (
        <div className="board_table_ellipse" style={{ height: `${height}px` }}>
            <div className="ellipsa_xx">

                <div className="elipse_wrapper">

                    <div className="ellipse" style={{ height: `${elipseHeight}px`, width: `${elipseWidth}px` }} >
                        
                        <div style={{ width: "100%", height: "90%" }} className="full_width center_horizontally_and_vertically">
                            <div className={`table_logo ${blureTheElement}`}>
                                <img src={logoUppiness} alt="logo on the table" />
                            </div>
                            <ChallengeCardOnTheTable />
                        </div>
                    </div>
                    
                    {playersInNewOrder.map((player: IPlayer, index: number) => {
                        if (!player) return <div></div>
                        return (
                            <AvatarBoxHolder key={index} index={index} player={player} oldAngleInDegrees={oldUserAngles[index]} angleInDegrees={userAngles[index]} ellipseWidth={elipseWidth} ellipseHeight={elipseHeight} avatarColor={`avatar_${player.color}`} />
                        )
                    })}

                </div>

            </div>
        </div>
    )
}
const BoardTableEllipse = React.memo( BoardTableEllipseMemo );

export default BoardTableEllipse;